<div class="container-fluid">
  <div class="report-header">
    <div>
      <h1 class="report-title">Dias parado no status/etapa</h1>
      <p class="report-subtitle">
        Encontre rapidamente o que travou: sem movimento, sem checklist, sem atualização.
      </p>
    </div>
  </div>

  <div class="panel report-filters">
    <div class="report-filters__grid">
      <div class="filter-field">
        <label for="filterStart">Período (início)</label>
        <input
          id="filterStart"
          type="date"
          class="form-control"
          [(ngModel)]="filterStart"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterEnd">Período (fim)</label>
        <input
          id="filterEnd"
          type="date"
          class="form-control"
          [(ngModel)]="filterEnd"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterSeguradora">Seguradora</label>
        <select
          id="filterSeguradora"
          class="form-control"
          [(ngModel)]="filterSeguradora"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let seguradora of seguradoras" [value]="seguradora">
            {{ seguradora }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterResponsavel">Responsável atual</label>
        <select
          id="filterResponsavel"
          class="form-control"
          [(ngModel)]="filterResponsavel"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let responsavel of responsaveis" [value]="responsavel">
            {{ responsavel }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterEtapa">Etapa atual</label>
        <select
          id="filterEtapa"
          class="form-control"
          [(ngModel)]="filterEtapa"
          (change)="applyFilters()"
        >
          <option value="TODAS">Todas</option>
          <option *ngFor="let etapa of etapas" [value]="etapa">{{ etapa }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterStatus">Status</label>
        <select
          id="filterStatus"
          class="form-control"
          [(ngModel)]="filterStatus"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option value="EM_ANDAMENTO">Em andamento</option>
          <option value="CONCLUIDO">Finalizado</option>
          <option value="ATRASADO">Em atraso</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterParado">Parado há (dias)</label>
        <input
          id="filterParado"
          type="number"
          min="0"
          class="form-control"
          [(ngModel)]="paradoDias"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field filter-field--inline">
        <label>
          <input type="checkbox" [(ngModel)]="onlyWip" (change)="applyFilters()" />
          Somente em produção (WIP)
        </label>
      </div>
      <div class="filter-field filter-field--inline">
        <label>
          <input type="checkbox" [(ngModel)]="onlyAtraso" (change)="applyFilters()" />
          Somente com atraso
        </label>
      </div>
      <div class="filter-field">
        <label for="filterOrder">Ordenação</label>
        <select
          id="filterOrder"
          class="form-control"
          [(ngModel)]="orderBy"
          (change)="applyFilters()"
        >
          <option value="PARADO">Mais parado primeiro</option>
          <option value="ATRASO">Mais atrasado primeiro</option>
          <option value="ANTIGO">Mais antigo primeiro</option>
        </select>
      </div>
    </div>
  </div>

  <div class="report-kpis">
    <div class="kpi-card">
      <div class="kpi-label">Total analisado</div>
      <div class="kpi-value">{{ totalAnalisado }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Total parados</div>
      <div class="kpi-value">{{ totalParados }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Parados críticos (= 7 dias)</div>
      <div class="kpi-value">{{ paradosCriticos }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Em atraso dentro dos parados</div>
      <div class="kpi-value">{{ paradosEmAtraso }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Maior tempo parado</div>
      <div class="kpi-value">{{ maiorParado }} dias</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Média de dias parado</div>
      <div class="kpi-value">{{ mediaParado }} dias</div>
    </div>
  </div>

  <div class="tabs-pill report-tabs" role="tablist">
    <button class="tab-btn" [class.active]="activeTab === 'lista'" (click)="activeTab = 'lista'">
      Lista
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'etapa'" (click)="activeTab = 'etapa'">
      Por etapa
    </button>
    <button
      class="tab-btn"
      [class.active]="activeTab === 'responsavel'"
      (click)="activeTab = 'responsavel'"
    >
      Por responsável
    </button>
  </div>

  <div *ngIf="activeTab === 'lista'" class="panel report-table">
    <div class="wf-table-card">
      <table class="wf-table">
        <thead>
          <tr>
            <th class="col-number">OS</th>
            <th>Placa / Veículo</th>
            <th class="col-stage">Etapa atual</th>
            <th class="col-user">Responsável</th>
            <th class="col-date">Última atividade</th>
            <th class="col-days">Dias parado</th>
            <th class="col-date">Final previsto</th>
            <th class="col-days">Atraso</th>
            <th class="col-sinais">Sinais</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of paradosItems"
            [class.row-late]="item.emAtraso"
            class="row-clickable"
            (click)="goToWorkflow(item.workflow.id)"
          >
            <td class="col-number">{{ item.osNumero }}</td>
            <td>{{ item.veiculo }}</td>
            <td class="col-stage">{{ item.etapaAtual }}</td>
            <td class="col-user">{{ item.responsavel }}</td>
            <td class="col-date">{{ item.ultimaAtividade | date: 'dd/MM/yyyy' }}</td>
            <td class="col-days">
              <span class="badge" [ngClass]="getStatusBadge(item)">{{ item.diasParado }}d</span>
            </td>
            <td class="col-date">
              {{ item.dataFinalPrevista ? (item.dataFinalPrevista | date: 'dd/MM/yyyy') : '—' }}
            </td>
            <td class="col-days">{{ item.atrasoDias }}</td>
            <td class="col-sinais">
              <span class="signal" [class.active]="item.sinais.checklist">?</span>
              <span class="signal" [class.active]="item.sinais.comentario">??</span>
              <span class="signal" [class.active]="item.sinais.anexo">??</span>
              <span class="signal" [class.active]="item.sinais.comunicacao">??</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="activeTab === 'etapa'" class="stage-grid">
    <div class="stage-card" *ngFor="let group of gruposEtapa">
      <div class="stage-card__header">
        <div class="stage-title">{{ group.etapa }}</div>
        <div class="stage-count">{{ group.parados }}</div>
      </div>
      <div class="stage-chips">
        <span class="chip chip--danger">Críticos: {{ group.criticos }}</span>
        <span class="chip chip--warning">M—x: {{ group.maxDias }}d</span>
      </div>
      <div class="stage-meta">Média: {{ group.mediaDias }} dias</div>
      <div class="stage-mini">
        <div class="stage-mini__title">Top 3 parados</div>
        <div class="stage-mini__item" *ngFor="let item of group.top3">
          <span>{{ item.veiculo }}</span>
          <span class="muted">{{ item.diasParado }}d</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'responsavel'" class="person-layout">
    <div class="person-list">
      <button
        class="person-card"
        *ngFor="let group of gruposResponsavel"
        [class.active]="selectedResponsavel === group.responsavel"
        (click)="selectedResponsavel = group.responsavel"
      >
        <div class="person-name">{{ group.responsavel }}</div>
        <div class="person-metrics">
          <span>Parados: {{ group.parados }}</span>
          <span>Críticos: {{ group.criticos }}</span>
        </div>
        <div class="person-meta">Etapa mais comum: {{ group.etapaTop }}</div>
      </button>
    </div>

    <div class="person-detail">
      <div class="panel report-table" *ngIf="selectedResponsavel">
        <h2 class="section-title">Itens de {{ selectedResponsavel }}</h2>
        <div class="wf-table-card">
          <table class="wf-table">
            <thead>
              <tr>
                <th class="col-number">OS</th>
                <th>Placa / Veículo</th>
                <th class="col-stage">Etapa</th>
                <th class="col-date">Última atividade</th>
                <th class="col-days">Dias parado</th>
                <th class="col-days">Atraso</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of selectedResponsavelItems">
                <td class="col-number">{{ item.osNumero }}</td>
                <td>{{ item.veiculo }}</td>
                <td class="col-stage">{{ item.etapaAtual }}</td>
                <td class="col-date">{{ item.ultimaAtividade | date: 'dd/MM/yyyy' }}</td>
                <td class="col-days">{{ item.diasParado }}</td>
                <td class="col-days">{{ item.atrasoDias }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
